import { useEffect, useState } from 'react';

export const useDarkMode = () => {
    const [darkMode, setDarkMode] = useState<boolean>(localStorage.getItem("darkMode") === "true");

    useEffect(() => {
        setDarkMode(localStorage.getItem("darkMode") === "true");
    }, [localStorage.getItem("darkMode")]);

    return {
        darkMode,
    };
};